import AccountSettingsModule from '@/modules/account-settings';

const AccountSettings = () => {
  return <AccountSettingsModule />;
};

export default AccountSettings;
